import { useContext } from "react";
import { useState, useEffect } from "react";
import { createContext } from "react";

export const MyOtpContext = createContext();

export default function OtpContext({ children }) {
  //   const [otpStatus, setOtpStatus] = useState(
  //     () => {
  //     const otp = JSON.parse(localStorage.getItem("otpstatus"));
  //     return otp ||

  //     false;
  //   });
  const [otpStatus, setOtpStatus] = useState(false);
  const [brochedureId, setBrochedureId] = useState(null);

  //   const [otpEmail, setOtpEmail] = useState(() => {
  //     const otpname = JSON.parse(localStorage.getItem("verifyemail"));
  //     return otpname || "";
  //   });
  const [otpEmail, setOtpEmail] = useState("");
  return (
    <MyOtpContext.Provider
      value={{
        otpStatus,
        setOtpStatus,
        otpEmail,
        setOtpEmail,
        brochedureId,
        setBrochedureId,
      }}
    >
      {children}
    </MyOtpContext.Provider>
  );
}

export const useOtpSTatus = () => {
  return useContext(MyOtpContext);
};
